import { createElement } from 'react';
import PropTypes from 'prop-types';
import svg from './svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var CrossChild = function CrossChild(_ref) {
  var offset = _ref.offset;
  return /*#__PURE__*/_jsxs("g", {
    transform: "translate(".concat(offset, " ").concat(offset, ")"),
    children: [/*#__PURE__*/_jsx("path", {
      vectorEffect: "non-scaling-stroke",
      d: "M 1,1 31,31"
    }), /*#__PURE__*/_jsx("path", {
      vectorEffect: "non-scaling-stroke",
      d: "M 1,31 31,1"
    })]
  });
};
CrossChild.propTypes = {
  offset: PropTypes.number
};
var Cross = function Cross(props) {
  return /*#__PURE__*/createElement(svg, props, CrossChild);
};
export default Cross;